import { FC } from "react";

interface ProgressCircleProps {
  active: boolean;
  text?: string;
  key?: any;
}

const ProgressCircle: FC<ProgressCircleProps> = ({ active, text }) => {
  const outerCircleClassNames = [
    "z-[2] w-8 h-8 relative rounded-full bg-white border-solid border-2",
    active ? "border-nivabupa-blue-light" : "border-nivabupa-gray",
    "flex justify-center items-center", // Added alignment classes to always center the dot
  ];
  const innerCircleClassNames = [
    "w-2.5 h-2.5 rounded-full",
    active ? "bg-nivabupa-blue-light" : "bg-nivabupa-gray opacity-40",
  ];
  const outerCircleClassName = outerCircleClassNames.join(" ");
  const innerCircleClassName = innerCircleClassNames.join(" ");
  return (
    <div>
      <div className="flex justify-center relative">
        <div className={outerCircleClassName}>
          <div className={innerCircleClassName}></div>
        </div>
        {text ? (
          <div className="text-center absolute top-9 w-24 md:text-sm text-xs">
            {text}
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default ProgressCircle;
